export enum ThirdPartyAppType {
  ZOOM_APP = '1',
}
